import { BUILDING_QUOTE_STATUS } from 'src/shared/consts/quoteStatus'

/** Query params for /my-account/requests list (segment + delivered sub-list). */
export const REQUEST_MODE_QUERY_KEY = 'mode'
export const REQUEST_EXPLORE_MODE = 'explore'

export const REQUEST_SEGMENT_QUERY_KEY = 'segment'
export const REQUEST_LIST_QUERY_KEY = 'requestList'
/** @deprecated Legacy query key — parsed for backward-compatible URLs */
export const LEGACY_REQUEST_LIST_QUERY_KEY = 'orderList'

export type RequestSegment = 'all' | 'active' | 'delivered' | 'drafts'
export type RequestListTab = 'requests' | 'items'

export const DEFAULT_REQUEST_SEGMENT: RequestSegment = 'all'

export function parseRequestSegment(value: string | null): RequestSegment {
  if (
    value === 'active' ||
    value === 'delivered' ||
    value === 'drafts'
  ) {
    return value
  }
  return 'all'
}

export function parseRequestListTab(
  value: string | null,
  legacyValue?: string | null
): RequestListTab {
  const raw = value ?? legacyValue
  return raw === 'items' ? 'items' : 'requests'
}

/** Alias for draft segment filter (includes `null` via `isDraftQuoteStatus`) */
export const DRAFT_QUOTE_STATUS = BUILDING_QUOTE_STATUS

/** @deprecated Legacy explore mode via query param — use paths.guidedAssistant instead */
export function isRequestExploreMode(searchParams: URLSearchParams) {
  return searchParams.get(REQUEST_MODE_QUERY_KEY) === REQUEST_EXPLORE_MODE
}

/** @deprecated Use buildGuidedAssistantPath from src/routes/paths */
export function buildRequestExploreSearch() {
  return `?${REQUEST_MODE_QUERY_KEY}=${REQUEST_EXPLORE_MODE}`
}

export function buildRequestsListSearch(params: {
  segment?: RequestSegment
  requestList?: RequestListTab
}) {
  const sp = new URLSearchParams()
  if (params.segment && params.segment !== DEFAULT_REQUEST_SEGMENT) {
    sp.set(REQUEST_SEGMENT_QUERY_KEY, params.segment)
  }
  if (
    params.segment === 'delivered' &&
    params.requestList &&
    params.requestList !== 'requests'
  ) {
    sp.set(REQUEST_LIST_QUERY_KEY, params.requestList)
  }
  const q = sp.toString()
  return q ? `?${q}` : ''
}

/** @deprecated Use parseRequestSegment */
export const parseOrderSegment = parseRequestSegment
/** @deprecated Use parseRequestListTab */
export const parseOrderListTab = parseRequestListTab
/** @deprecated Use buildRequestsListSearch */
export const buildOrdersListSearch = (params: {
  segment?: RequestSegment
  orderList?: RequestListTab
}) =>
  buildRequestsListSearch({
    segment: params.segment,
    requestList: params.orderList,
  })

/** @deprecated Use DEFAULT_REQUEST_SEGMENT */
export const DEFAULT_ORDER_SEGMENT = DEFAULT_REQUEST_SEGMENT
/** @deprecated Use REQUEST_SEGMENT_QUERY_KEY */
export const ORDER_SEGMENT_QUERY_KEY = REQUEST_SEGMENT_QUERY_KEY
/** @deprecated Use REQUEST_LIST_QUERY_KEY */
export const ORDER_LIST_QUERY_KEY = REQUEST_LIST_QUERY_KEY
/** @deprecated Use RequestSegment */
export type OrderSegment = RequestSegment
/** @deprecated Use RequestListTab */
export type OrderListTab = RequestListTab
